import logo from '../assets/kpsLogo.png'
import {useState, useEffect} from 'react'

export default function Klogo({ className }) {

    const [isLoaded, setIsLoaded ] = useState(false)
    
    useEffect(() => {
        setIsLoaded(false)
        setIsLoaded(true)
        const timer = setTimeout(() => setIsLoaded(true), 100)
        return () => { // done to execute onyl when we need it to
            clearTimeout(timer)
        }
    }, [])

    return (
        <div className="flex justify-center">
  <img
    className={`
      ${className || "w-[700px] sm:w-[550px] md:w-[700px]"} max-w-full h-auto
      transition-opacity duration-1000 ease-in 
      ${isLoaded ? 'opacity-100' : 'opacity-0'}
    `}
    src={logo}
    alt="Kpop Logo"
  />
</div>

    )
}